import React, { useState } from 'react';
import ApsAppointeeData from './Views/ApsAppointeeData/ApsAppointeeData.view';
import AppointeeContractResponse from './Views/AppointeeContractResponse/AppointeeContractResponse.view';
import AppointeeExceptionReasons from './Views/AppointeeExceptionCenterReasons/AppointeeExceptionReasons.view';

import Menu from './Views/MenuView/Menu.view';
import Typography from '@material-ui/core/Typography';

const MarkersAppointeeManagement = props => {
	const {
		location: { state: { title = 'Appointee Management' } = {} }
	} = props;
	const [activeModal, setActiveModal] = useState('');

	const handleActiveModal = (menuName = '') => setActiveModal(menuName);

	switch (activeModal) {
		case 'apsAppointeeData': {
			return <ApsAppointeeData handleActiveModal={handleActiveModal} />;
		}
		case 'appointeeContractResponseData': {
			return <AppointeeContractResponse handleActiveModal={handleActiveModal} />;
		}
		case 'appointeeExceptionReasons': {
			return <AppointeeExceptionReasons handleActiveModal={handleActiveModal} />;
		}
		default:
			return (
				<>
					<Menu handleActiveModal={handleActiveModal} />
				</>
			);
	}
};

export default MarkersAppointeeManagement;
